module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showLabel) ? _c('label', {
    staticClass: "label-control",
    attrs: {
      "for": "form-employee"
    }
  }, [_vm._v("Pracownik:")]) : _vm._e(), _vm._v(" "), _c('vs-select', {
    attrs: {
      "autocomplete": "",
      "id": "form-employee"
    },
    model: {
      value: (_vm.employee),
      callback: function($$v) {
        _vm.employee = $$v
      },
      expression: "employee"
    }
  }, _vm._l((_vm.getFilteredEmployeeNames()), function(item) {
    return _c('vs-select-item', {
      key: item,
      attrs: {
        "value": item,
        "text": item
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1a3e4966!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/SelectEmployee.vue
// module id = 1088
// module chunks = 0